import React, { Component } from 'react';
import { connect } from 'react-redux'
import CvTable from '../cv/CvTable'
import '../../assets/css/requisition.css'
import requisitionStyle from '../../assets/jss/requisitionStyle'
import PropTypes from 'prop-types'
import { 
    withStyles,
    Button
} from '@material-ui/core';
import { 
    getCvList,
    getCvListWithCookies
} from '../../actions/CvActions'
import {
    withCookies
} from 'react-cookie'
import GridContainer from '../../components/Grid/GridContainer'
import GridItem from '../../components/Grid/GridItem'
import * as Sentry from '@sentry/browser'
import {
    NavLink,
} from 'react-router-dom'
import {
    ROUTE_REQUISITION_LIST,
    ROUTE_ADMIN_CV,
    ROUTE_ADMIN_JOB,
    ROUTE_ADMIN_LOGIN,
    ROUTE_ADMIN_CREATE_JOB
} from '../../utils/routes'
import {
    JWT
} from '../../utils/CommonConstant'
import {
    logout
} from '../../actions/LoginAction'
import InformationDialog from '../../components/Dialog/InformationDialog'

Sentry.init({
    dsn: "https://8b7fd3762e754bab8c1c1e62dd17f0db@sentry.io/1388765"
});

class Cvlist extends Component {

    constructor() {
        super();
        this.state = {
          page_index: 1,
          open: false,
        }
    }

    componentWillMount() {
         //this.props.getCvList(1)
        this.props.getCvListWithCookies(1, this.props.cookies.cookies.jwt === undefined ?  sessionStorage.getItem(JWT) : this.props.cookies.cookies.jwt)
    }

    componentDidCatch(error, errorInfo) {
        Sentry.withScope(scope => {
          Object.keys(errorInfo).forEach(key => {
            scope.setExtra(key, errorInfo[key]);
          });
          Sentry.captureException(error);
        });
    }

    render(){

        const { classes } = this.props

        return (
            <div className={classes.main}>

                    <InformationDialog
                        open={this.state.open}
                        handleClose={this.handleClose}
                        handleLogout={this.handleLogout}
                    />
                <div className="Content">

                <div className="CvBtn">

                    <NavLink  from={ROUTE_ADMIN_CV} to={ROUTE_REQUISITION_LIST}>
                        <Button  className={classes.nav_button} variant="outlined" color="secondary">
                            View Requisitions
                        </Button>
                    </NavLink>

                    <NavLink from={ROUTE_ADMIN_CV} to={ROUTE_ADMIN_JOB}>
                        <Button className={classes.nav_button} variant="outlined" color="secondary">
                            View Jobs
                        </Button>
                    </NavLink>
                    <NavLink  from={ROUTE_ADMIN_CV} to={ROUTE_ADMIN_CREATE_JOB}>
                        <Button variant="outlined" className={classes.nav_button}  color="secondary">
                            Create Job
                        </Button>
                    </NavLink>
                    <NavLink disabled={true} from={ROUTE_ADMIN_CV} to={ROUTE_ADMIN_CV}>
                        <Button disabled={true} variant="outlined" className={classes.nav_button} color="secondary">
                            View CVs
                        </Button>
                    </NavLink>

                    <Button 
                        onClick={() => this.onLogout()}
                        variant="outlined" 
                        className={classes.nav_button} 
                        color="secondary">
                        Logout
                    </Button>
                    
                </div>

                    <CvTable
                        tableHeadColor = "primary"
                        tableHead = {["Name","Email", "Yoma Employee", "Current Position","Applied Position", "Received Date", "More"]}
                        tableData = {this.props.cv.list}     
                    />

                    <GridContainer>

                        <GridItem xs={12} sm={12} md={6}>
                            <Button
                                className={classes.next_button}
                                color="secondary"
                                variant="contained"
                                disabled={this.state.page_index === 1} 
                                onClick={() => this.handlePrev()}>
                                Prev Page
                            </Button>
                        </GridItem>

                        <GridItem xs={12} sm={12} md={6}>
                            <div className="PageButton">
                                <Button 
                                    className={classes.next_button}
                                    disabled={this.props.cv.list < 20}
                                    color="secondary"
                                    variant="contained"
                                    onClick={() => this.handleNext()}>
                                    Next Page
                                </Button>
                            </div>
                        </GridItem>

                    </GridContainer>
                </div>
            </div>
        );
    }

    onLogout = () => {
        this.setState({
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    }

    handleLogout = () => {
        this.setState({
            open: false
        })
        this.props.logout()
        this.props.history.replace(ROUTE_ADMIN_LOGIN, { firstPage: true});
       // this.props.history.push(ROUTE_ADMIN_LOGIN);
    }

    handleOnApprve = (item) => {
        this.props.updateRequisitionStatus({item, status: "accepted"})
    }

    handleOnDecline = (item) => {
        
        this.props.updateRequisitionStatus({item, status: "declined"})
    }

    handleNext = () => {

        this.setState( state => ({
            page_index: state.page_index + 1
        }))
      
       // this.props.getCvList(this.state.page_index +1)
       this.props.getCvListWithCookies(this.state.page_index +1, this.props.cookies.cookies.jwt === undefined ?  sessionStorage.getItem(JWT) : this.props.cookies.cookies.jwt)
    }

    handlePrev = () => {

        if(this.state.page_index > 1) {
            this.setState( state => ({
                page_index: state.page_index - 1
            }))
        }
     
       // this.props.getCvList(this.state.page_index - 1)
       this.props.getCvListWithCookies(this.state.page_index - 1, this.props.cookies.cookies.jwt === undefined ?  sessionStorage.getItem(JWT) : this.props.cookies.cookies.jwt)
    }
}

Cvlist.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapDispatchToProps = (dispatch) => ({
    getCvList: (page_index) => {
      dispatch(
        getCvList(page_index)
      )
    },
    getCvListWithCookies: (page_index, jwt) => {
        dispatch(
            getCvListWithCookies(page_index, jwt)
        )
    },
    logout: () => {
        dispatch(
            logout()
        )
    }
  })
  
const mapStateToProps = (state, ownProps) => ({
    cv: state.cvs,
    ownProps: ownProps.cookies
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(requisitionStyle)(withCookies(Cvlist)));